import { Notify } from "@/components/ui/notify";
import type { AppliedScenarioOrderView } from "@/types/applied-scenario.types";

interface FrozenScopeListProps {
  orders: AppliedScenarioOrderView[];
}

// O ESCOPO CONGELADO: as ordens que o compromisso abrange, com a quantidade
// CONGELADA no ato. A tela diz isso em voz alta porque o número aqui pode divergir do que a mesma
// OP mostra na tela de ordens — e essa divergência é o comportamento correto, não um bug.

export function FrozenScopeList({ orders }: FrozenScopeListProps) {
  if (orders.length === 0) {
    return (
      <Notify.Empty
        variant="inline"
        title="Nenhuma ordem no escopo"
        description="Nenhuma Ordem de Produção cruzava a vigência quando o cenário foi aplicado. A apuração vai medir a janela sem produção comprometida."
      />
    );
  }

  return (
    <div className="space-y-2">
      <p className="text-[12px] text-text-secondary">
        Quantidades <strong className="font-medium text-text-primary">congeladas</strong> no momento
        da aplicação — editar a ordem depois não muda o que foi comprometido.
      </p>
      <ul className="divide-y divide-border-subtle rounded-md border border-border-subtle">
        {orders.map((order) => (
          <li
            key={order.productionOrderId}
            className="flex items-center justify-between gap-3 px-3 py-2 text-sm"
          >
            <span className="flex items-center gap-2">
              <span className="text-[11px] tabular-nums text-text-tertiary">
                {order.position + 1}
              </span>
              <span className="font-medium">{order.code ?? "Ordem sem código"}</span>
            </span>
            <span className="tabular-nums text-text-secondary">
              {order.plannedQty.toLocaleString("pt-BR")} un
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
